import type { CSSProperties } from "react";

/**
 * Accent colours used as text or icon colour on service surfaces.
 *
 * The dark-theme accent #00d4aa is 1.91:1 on white, so the light theme
 * swaps it for --eyebrow's #007a5e (5.32:1 on #ffffff, 5.05:1 on
 * #f8f9fb). #0066ff passes in the light theme (4.83:1 on white) but is
 * only 4.22:1 on the dark surface #050505, so the dark theme uses #4d94ff
 * (6.2:1 on #050505).
 *
 * Pair the returned style with the `accent-ink` class from globals.css.
 */
const LIGHT_THEME_INK: Record<string, string> = {
  "#00d4aa": "#007a5e",
  // Network Advisor service and summary colours (light theme only):
  // #22c55e is 2.28:1 on white, #166534 is 7.13:1; #f97316 is 2.8:1,
  // #9a3412 is 7.31:1.
  "#22c55e": "#166534",
  "#f97316": "#9a3412",
  // #0066ff is 4.83:1 on white but 3.77:1 on the blue-tinted service
  // cards; #0047b3 is >= 6.1:1 there. ROI savings use #ef4444 for
  // negative values (3.76:1 on white); #b91c1c is 6.47:1.
  "#0066ff": "#0047b3",
  "#ef4444": "#b91c1c",
};
const DARK_THEME_INK: Record<string, string> = {
  "#0066ff": "#4d94ff",
};

export function accentInkStyle(accent: string, extra?: CSSProperties): CSSProperties {
  return {
    ...extra,
    ["--accent-ink" as string]: DARK_THEME_INK[accent.toLowerCase()] ?? accent,
    ["--accent-ink-light" as string]: LIGHT_THEME_INK[accent.toLowerCase()] ?? accent,
  } as CSSProperties;
}
